import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type {
  TeamPerformanceParams,
  TeamPerformanceResponse,
} from '@/types/teamPerformance'

/**
 * Dashboard manager : leaderboard agents + totaux équipe + comparaison N-1.
 *
 * Backend : telephony/views.py::team_performance
 * Endpoint : GET /api/companies/{companyId}/team-performance/
 *
 * Le hook ne fire que si `companyId` est défini (évite un 401 pendant le boot
 * quand le profil n'est pas encore résolu). staleTime court (30s) car les
 * managers regardent ce dashboard en quasi-temps réel pendant les heures de pointe.
 */
export function useTeamPerformance(
  companyId: number | undefined,
  params: TeamPerformanceParams,
) {
  return useQuery({
    queryKey: ['team-performance', companyId, params],
    queryFn: async () => {
      const { data } = await api.get<TeamPerformanceResponse>(
        `/api/companies/${companyId}/team-performance/`,
        { params },
      )
      return data
    },
    enabled: Boolean(companyId),
    staleTime: 30_000,
  })
}
